import { IBaseModel } from '../base';
import moment from 'moment';
import { IGlCode } from '../masterData/glCode/glCode';
import { IJob } from '../job/job';
import { ICustomer } from '../masterData/customer/customer';
import { IDivision } from '../masterData/division/division';

export enum RequisitionStatus {
    Cancelled,
    Draft,
    Submitted,
    Ordered,
    PartiallyReceived,
    Received,
    Closed,
    Approved,
    Declined
}

export enum RequisitionLineStatus {
    Cancelled,
    Draft,
    Submitted,
    Ordered,
    PartiallyReceived,
    Received,
    Closed,
}

export enum RequisitionType {
    Procurement,
    Stores,
    Capital,
}

export interface IRequisition extends IBaseModel {
    requisitionNumber : string;
    orderNumber : string | null;
    defaultAllocationNumber : string | null;
    glCodeId : number | null;
    glCode : IGlCode | null;
    referenceDescription : string;
    referenceNumber : string | null;
    approverName : string | null;
    approverEmployeeNumber : string | null;
    approverDescription : string | null;
    status : RequisitionStatus;
    requestedOn : moment.Moment | null;
    requestedByName : string;
    requestedByEmployeeNo : string;
    approvedOn : moment.Moment | null;
    approvedByName : string | null;
    approvedByEmployeeNo : string | null;
    
    jobId : number | null;
    job : IJob | null;
    
    customerId : number | null;
    customer : ICustomer | null;

    divisionId : number;
    division : IDivision | null;
}
